module.exports = __webpack_public_path__ + "static/media/Ghulam Rasool (Smith and Campbell 1922).c7bdc30d.jpg";